var _defs, _line, _line2, _line3, _line4, _line5, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#b3ddee;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2,.cls-3{stroke-width:2px;}.cls-2,.cls-3{stroke:#0090b9;stroke-miterlimit:10;}.cls-3{fill:#b3ddee;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.55,
    y1: 40.36,
    x2: 67.11,
    y2: 40.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.55,
    y1: 50.74,
    x2: 67.11,
    y2: 50.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.55,
    y1: 61.12,
    x2: 67.11,
    y2: 61.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.55,
    y1: 71.36,
    x2: 67.11,
    y2: 71.36
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.55,
    y1: 81.74,
    x2: 57.04,
    y2: 81.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.64,41.91V95.13A4.63,4.63,0,0,1,75,99.76H18a4.63,4.63,0,0,1-4.64-4.63V20A4.64,4.64,0,0,1,18,15.4H53.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.85,41.9H58.39a5.32,5.32,0,0,1-5.32-5.32V17.18a.74.74,0,0,1,1.27-.52l24,24A.74.74,0,0,1,77.85,41.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.01c875521bd4ef8c6554eb8cd8858ae2.svg";
export { ForwardRef as ReactComponent };